import script from "./Welcome.vue?vue&type=script&setup=true&lang=js"
export * from "./Welcome.vue?vue&type=script&setup=true&lang=js"

import "./Welcome.vue?vue&type=style&index=0&id=7b578968&lang=scss&scoped=true"
import "./Welcome.vue?vue&type=style&index=1&id=7b578968&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b578968"]])

export default __exports__